import { useState } from "react";

export const BrandLogo = ({ className, testId }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className="block font-extrabold tracking-[0.12em] text-white text-lg" data-testid={`${testId}-fallback`}>
        PRODIGY
      </span>
    );
  }
  return <img src="/logo-prodigy.png" alt="Prodigy" className={className} data-testid={testId} onError={() => setFailed(true)} />;
};
